import React, { useEffect, useState } from 'react';
interface PeerPollProps {
  percentage: number;
  label?: string;
}
export function PeerPoll({
  percentage,
  label = 'Based on HCP responses'
}: PeerPollProps) {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);
  return <div className="px-6 py-8 bg-gray-50" data-id="element-115">
      <div className="text-center mb-6" data-id="element-116">
        <p className="text-2xl font-bold text-roche-blue mb-2" data-id="element-117">
          {percentage}% of professionals answered like you.
        </p>
        <p className="text-sm text-text-secondary" data-id="element-118">{label}</p>
      </div>

      {/* Segmented bar chart */}
      <div className="relative h-12 bg-white rounded-lg overflow-hidden border border-border-gray" data-id="element-119">
        <div className={`h-full bg-gradient-to-r from-roche-blue to-roche-blue-dark ${isVisible ? 'bar-fill' : ''}`} style={{
        '--bar-width': `${percentage}%`,
        width: isVisible ? `${percentage}%` : '0%'
      } as React.CSSProperties} role="progressbar" aria-valuenow={percentage} aria-valuemin={0} aria-valuemax={100} aria-label={`${percentage}% of professionals`} data-id="element-120" />

        {/* Percentage label inside bar */}
        {isVisible && <div className="absolute inset-0 flex items-center justify-center" data-id="element-121">
            <span className="text-sm font-semibold text-white mix-blend-difference" data-id="element-122">
              {percentage}%
            </span>
          </div>}
      </div>
    </div>;
}